<div class="modals wholesalers" [class.modals-show]="isModalWholesalersShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4>Оптовикам:</h4>
  <ul>
    <li>На смарт-платформі <span class='alert'>MasloTochka</span> діє гнучка система знижок, в залежності від обсягів
      замовлень;
    </li>
    <li>Можливість робити замовлення 24/7;</li>
    <li>Dropshipping;</li>
    <li>Доставка та експрес-доставка товарів;</li>
    <li>Можливість онлайн контролювання статусу свого замовлення.</li>
  </ul>
  <br><br>
  <h4>Ми допоможемо Вам:</h4>
  <ul>
    <li>Розібратися з роботою на смарт-платформі;</li>
    <li>Зорієнтуватися в ассортименті;</li>
    <li>Зробити замовлення;</li>
    <li>Оптимізувати продажі.</li>
  </ul>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>

